APP.init = function () {
	APP.home()
}
